const cache = new Map()

export const getListCache = (key) => cache.get(key)

export const setListCache = (key, value) => {
  cache.set(key, value)
}

export const clearListCache = (prefix) => {
  for (const key of cache.keys()) {
    if (key.startsWith(prefix)) cache.delete(key)
  }
}

export const buildCacheKey = (scope, parts) => `${scope}:${JSON.stringify(parts)}`
